export const IcArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
    >
      <path
        d="M10.1958 0.132512C10.3987 -0.0546703 10.7146 -0.0420367 10.9019 0.160832L16.9019 6.66083L17.2153 6.9997L16.9019 7.33857L10.9019 13.8386C10.7146 14.0414 10.3987 14.054 10.1958 13.8669C9.9929 13.6796 9.98022 13.3637 10.1675 13.1608L15.3921 7.4997H1.28467C1.00853 7.4997 0.784668 7.27584 0.784668 6.9997C0.784747 6.72362 1.00857 6.4997 1.28467 6.4997H15.3921L10.1675 0.838567C9.98022 0.635655 9.9929 0.319802 10.1958 0.132512Z"
        fill="#5B5F63"
      />
    </svg>
  );
};
